<template>
    <div class="cluster-manage-wrapper">
        <ClusterList :data="hasClusterData" />
    </div>
</template>

<script>
import ClusterList from "./ClusterList";

export default {
    name: "ClusterManage",
    components: {
        ClusterList
    },
    data() {
        return {
            clusterDatas: ""
        };
    },
    mounted() {
        // 查询卡片列表，取消领取页
        this.getClusterCards();
    },
    computed: {
        hasClusterData() {
            let cardsData = this.getStorePorp("clusterCards");
            // eslint-disable-next-line
            return (this.clusterDatas = cardsData);
        }
    },
    methods: {
        getStorePorp(propName) {
            return this.$store.state.zhiji.questionCluster[propName];
        },
        getClusterCards() {
            this.$store.dispatch("zhiji/queryCardList", {
                page: 1,
                lang: "en"
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.cluster-manage-wrapper {
    height: 100%;
    background: #f2f7fb;
}
</style>
